import useEmblaCarousel from "embla-carousel-react";
import { Card } from "../../../components/ui/card";
import { Star } from "lucide-react";

export type TestimonialItem = {
  name: string;
  role: string;
  content: string;
  rating: number;
};

function TestimonialCard({ t }: { t: TestimonialItem }) {
  return (
    <Card className="border-white/10 bg-slate-900/60 p-5 backdrop-blur-md sm:p-8">
      <div className="mb-4 flex gap-1">
        {[...Array(t.rating)].map((_, i) => (
          <Star key={i} className="h-5 w-5 fill-amber-400 text-amber-400" />
        ))}
      </div>
      <p className="text-sm leading-relaxed text-slate-200">“{t.content}”</p>
      <div className="mt-6 border-t border-white/10 pt-4">
        <p className="font-medium text-white">{t.name}</p>
        <p className="text-xs text-teal-300/90">{t.role}</p>
      </div>
    </Card>
  );
}

type TestimonialsCarouselProps = {
  items: TestimonialItem[];
};

export function TestimonialsCarousel({ items }: TestimonialsCarouselProps) {
  const [emblaRef] = useEmblaCarousel({ loop: true, align: "center" });

  return (
    <div className="mt-14">
      <div className="md:hidden">
        <div className="overflow-hidden pb-2" ref={emblaRef}>
          <div className="flex touch-pan-y">
            {items.map((t) => (
              <div className="min-w-0 shrink-0 grow-0 basis-full px-2" key={t.name}>
                <TestimonialCard t={t} />
              </div>
            ))}
          </div>
        </div>
        <p className="mt-3 text-center text-xs text-slate-500">Deslize para ver mais depoimentos</p>
      </div>

      <div className="mx-auto hidden max-w-6xl gap-6 md:grid md:grid-cols-2 md:gap-8 lg:grid-cols-3">
        {items.map((t) => (
          <TestimonialCard key={t.name} t={t} />
        ))}
      </div>
    </div>
  );
}
